"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_REGION = exports.RegionHandle = void 0;
const WeekdayCalculator_1 = require("./WeekdayCalculator");
class RegionHandle {
    constructor(region) {
        this.region = region;
        this.id = region.id;
        this.name = region.name;
        this.holidays = region.holidays;
        this.workingHours = region.workingHours || 8;
        this.code = region.code || region.name;
    }
    getUtilizationPeriod(from, to) {
        const fromTime = from.getTime();
        const toTime = to.getTime();
        const weekdays = (0, WeekdayCalculator_1.calculateWeekDays)(from, to);
        const holidays = (this.region.holidays || []).filter((holiday) => {
            const date = new Date(holiday.year, holiday.month, holiday.day);
            const dateTime = date.getTime();
            return (date.getDay() !== 0 &&
                date.getDay() !== 6 &&
                dateTime >= fromTime &&
                dateTime <= toTime);
        });
        return {
            region: this.region,
            from,
            to,
            weekdays,
            holidays,
        };
    }
    getDisplayName() {
        return this.code || this.name || "";
    }
    compare(other) {
        const name1 = (this.name || "").toLowerCase();
        const name2 = (other.name || "").toLowerCase();
        return name1.localeCompare(name2);
    }
    countHolidaysInYear(year) {
        return (this.holidays || []).filter((holiday) => holiday.year === year)
            .length;
    }
}
exports.RegionHandle = RegionHandle;
exports.DEFAULT_REGION = new RegionHandle({
    id: "default",
    name: "default",
    holidays: [],
    workingHours: 8,
});
//# sourceMappingURL=RegionHandle.js.map